module.exports = __webpack_public_path__ + "static/media/Prospect_Bulk_Uploads.a003552b.mp4";